export const MOMENTUM_STYLE_CATEGORIES = ['momentum_continuations', 'high_probability'] as const;

type ModeContext = {
  standard_screening_enabled?: boolean;
  active_category?: string;
  bullish_momentum_enabled?: boolean;
  bullish_transition_enabled?: boolean;
  bearish_transition_enabled?: boolean;
};

export const isMomentumStyleActive = (activeCategory?: string): boolean =>
  MOMENTUM_STYLE_CATEGORIES.includes((activeCategory || '') as (typeof MOMENTUM_STYLE_CATEGORIES)[number]);

/** FIX R4: Trend controls are hidden/deprecated, so lock is always false.
 * Keeping isMomentumStyleActive for potential future use but not using it for locking. */
export const isTrendFilterLockedByMode = (ctx: ModeContext): boolean =>
  false; // Trend controls are deprecated, never lock

/** Simplified: just return the context's value - no longer force momentum on based on style */
export const resolveBullishMomentumEffective = (ctx: ModeContext): boolean =>
  Boolean(ctx.bullish_momentum_enabled);

/** Resolve effective transition flags - currently always false (filters are hidden in UI) */
export const resolveTransitionEffective = (ctx: ModeContext): { bullish: boolean; bearish: boolean } => ({
  bullish: Boolean(ctx.bullish_transition_enabled),
  bearish: Boolean(ctx.bearish_transition_enabled),
});

